<template>
  <div class="factoring-customer-container">
    <!-- 业务列表 -->
    <div class="list-content">
      <template v-for="(item, index) in listConfig">
        <div class="info-one-textarea" :key="`${item.prop}-${index}`" v-if="item.type == 'textarea'">
          <div class="info-left">{{item.label}}</div>
          <div class="info-right">{{listData[item.prop]?listData[item.prop]:'无'}}</div>
        </div>
        <div class="info-one" :key="`${item.prop}-${index}`" v-else>
          <div class="info-left">{{item.label}}</div>
          <div class="info-right">{{listData[item.prop]?listData[item.prop]:'无'}}</div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
export default {
  name: "FactoringBuildProjectInfo",
  data() {
    return {
      listConfig: [
        {
          label: '客户名称',
          prop: 'custName',
        },{
          label: '客户类别',
          prop: 'custCategoryStr',
        },{
          label: '客户来源',
          prop: 'custSourceStr',
        },{
          label: '客户性质',
          prop: 'custAttributeStr',
        },{
          label: '所属行业',
          prop: 'industryStr',
        },{
          label: '企业类别',
          prop: 'guaranteeMethod',
        },{
          label: '企业规模',
          prop: 'enterpriseScaleStr',
        },{
          label: '统一社会信用代码',
          prop: 'unifiedSocialCreditCode',
        },{
          label: '注册资本(万元)',
          prop: 'registeredCapital',
        },{
          label: '成立时间',
          prop: 'fundingTime',
        },{
          label: '联系电话',
          prop: 'contactNumber',
        },{
          label: '注册地址',
          prop: 'registeredAddress',
        },{
          label: '办公地址',
          prop: 'officeAddress',
        },{
          label: '企业概况',
          prop: 'custCompanyState',
          type: 'textarea'
        },{
          label: '主要产品及销售状况',
          prop: 'custProductSalesState',
          type: 'textarea'
        },{
          label: '资产负债情况',
          prop: 'custPropertyState',
          type: 'textarea'
        },{
          label: '其它',
          prop: 'custOther',
          type: 'textarea'
        }
      ],
    }
  },
  props: {
    listData: {
      type: Array,
      default: () => {
        return {}
      }
    }
  }  
}
</script>
<style lang="scss" scoped>
.factoring-customer-container{
  .table-title{
    width: 100%;
    height: 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    line-height: 1rem;
    margin-top: .2rem;
    padding-left: .3rem;
    padding-right: .3rem;
    .title-left{
      font-size: .38rem;
      color: #666;
      font-weight: 600;
    }
    .title-right{
      font-size: .38rem;
      color: #ccc;
    }
  }
  .index-title{
    height: 1rem;
    background-color: #fff;
    line-height: 1rem;
    position: relative;
    text-indent: .3rem;
  }
  .index-title::before{
    position: absolute;
    left: 0;
    top: 0;
    width: 0.1rem;
    height: 1rem;
    content: '';
    background-color: #409eff;
  }
  .list-content{
    .info-one{
      background-color: #fff;
      border-top:  .5px solid #f2f2f2;
      border-bottom:  .5px solid #f2f2f2;
      padding-left: .3rem;
      padding-right: .3rem;      
      display: flex;
      justify-content: space-between;
      align-items: center;
      min-height: 1.2rem;
      padding-top: 0.15rem;
      padding-bottom: 0.15rem;
      .info-left{
        width: 36%;
        color: #999;
        font-size: .38rem;
      }
      .info-right{
        width: 65%;
        font-size: .38rem;
        text-align: right;
        color: #333;
        overflow: hidden;
        text-overflow: ellipsis;
        // white-space: nowrap;
      }
    }
    .info-one-textarea{
      background-color: #fff;
      border-top:  .5px solid #f2f2f2;
      border-bottom:  .5px solid #f2f2f2;
      padding-left: .3rem;
      padding-right: .3rem;      
      // display: flex;
      // justify-content: space-between;
      // align-items: center;
      // height: 1.2rem;
      .info-left{
        width: 100%;
        color: #999;
        font-size: .38rem;
        height: 1.2rem;
        line-height: 1.2rem;
      }
      .info-right{
        width: 100%;
        font-size: .38rem;
        // text-align: right;
        color: #333;
        overflow: hidden;
        text-overflow: ellipsis;
        min-height: .3rem;
        padding-bottom: 0.3rem;
        // white-space: nowrap;
      }
    }
  }
  .item-one{
    background-color: #fff;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.05);
    width: 100%;
    padding: .35rem .4rem;
    border-radius: .2rem;
    margin-bottom: .2rem;
    .item-index{
      font-size: .38rem;
      line-height: .7rem;
      color: #999;
      font-weight: 600;
    }
    .item-line{
      font-size: .38rem;
      line-height: .55rem;
      color: #999;
      span{
        margin-left: .3rem;
      }
    }
    .remark-content{
      font-size: .38rem;
      color: #333;
      line-height: .7rem;
    }
  }
}
</style>